import { CareproviderLoginFormValues } from "./schema";

export function getCareproviderLoginDefaultValues(): CareproviderLoginFormValues {
  return {
    challenge: "",
    email: "",
    password: "",
  };
}
